module.exports = __webpack_public_path__ + "static/img/1.a438423.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/1.png
// module id = V4BO
// module chunks = 0